import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=4ff9e05e&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ff9e05e')) {
      api.createRecord('4ff9e05e', component.options)
    } else {
      api.reload('4ff9e05e', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=4ff9e05e&", function () {
      api.rerender('4ff9e05e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2uF5OhO5PjGL6/JS/comp/ErrorMessage.vue"
export default component.exports